
export default class General {
    constructor() {

        const updateBackgroundImages = () => {
            const width = window.innerWidth;
            const divs = document.querySelectorAll('div[data-hatterkep_mobile][data-hatterkep_desktop]');

            divs.forEach(div => {
                if (width > 991) {
                    div.style.backgroundImage = `url(${div.getAttribute('data-hatterkep_desktop')})`;
                } else {
                    div.style.backgroundImage = `url(${div.getAttribute('data-hatterkep_mobile')})`;
                }
            });
        };

        window.addEventListener('resize', updateBackgroundImages);

        updateBackgroundImages();

    }
}

